<template>
  <div>

      <div class="row col-12">

        <div class="col-md-12 col-sm-12}">
          <va-card style="min-height: 170px; height: 100%">
            <va-tabs v-model="tabValue" style="border-width: 2px" :disabled="true">
              <va-tab
                v-for="tab in viewType"
                :key="tab"
              >
                {{ $t(`dashboard_new_evollu.parameters.titles.${tab}`)}}
              </va-tab>
            </va-tabs>
            <v-client-table
              v-if="tabValue === 0"
              id="dataTable"
              ref="dataTable"
              name="dataTable"
              :data="data"
              :columns="columns"
              :options="tableOptions"
              @row-click="showAudiogramGraph"
            >
              <span slot="created_at" slot-scope="{row}">
                {{row.created_at}}
              </span>
              <span slot="automatic" slot-scope="{row}">
                <va-popover
                  v-if="row.automatic !== null && row.automatic === true"
                  placement="top"
                  :message="$t('checkup_plus.person.measurements.submitted_by.device')">
                  <i class="fa fa-tablet"/>
                </va-popover>
                <va-popover
                  v-else
                  placement="top"
                  :message="$t('checkup_plus.person.measurements.submitted_by.manual')">
                  <i class="fa fa-pencil"/>
                </va-popover>
              </span>
            </v-client-table>

            <div v-if="tabValue===1">
              <HearingTest
                v-if="hearingTestData"
                class="mt-4"
                :hideTitle="true"
                :show-average="true"
                :ht="hearingTestData"/>
            </div>
          </va-card>
        </div>
      </div>
  </div>
</template>

<script>
import { ClientTable } from 'vue-tables-2'
import Vue from "vue";
import ConfirmationModal from "@/components/common/ConfirmationModal";
import {OneCareService} from "@/api/OneCareService";
import HearingTest from "@/components/common/HearingTest";
Vue.use(ClientTable, {}, false, 'bootstrap4')
export default {
  components: {
    HearingTest,
    ClientTable,
  },
  props: {
    data: {
      type: Array,
      required: true
    },
    columns: {
      type: Array,
      required: true
    },
  },
  data: function () {
    return {
      tabValue: 0,
      viewType: ['table', 'graph'],
      hearingTestData: null,
      tableOptions: {
        sortable: [],
        filterable: false,
        headings: {
          created_at: this.$t('tables.columns.created_at'),
          notes: this.$t('dashboard_new_evollu.parameters.titles.notes'),
          systolic: this.$t('dashboard_new_evollu.measurement_types.systolic_short'),
          diastolic: this.$t('dashboard_new_evollu.measurement_types.diastolic_short'),
          heart_rate: this.$t('dashboard_new_evollu.measurement_types.heart_rate_short'),
          duration_session: this.$t('dashboard_new_evollu.measurement_types.duration_session_short'),
          oximetry_max: this.$t('dashboard_new_evollu.measurement_types.oximetry_max_short'),
          oximetry_min: this.$t('dashboard_new_evollu.measurement_types.oximetry_min_short'),
          oximetry_avg: this.$t('dashboard_new_evollu.measurement_types.oximetry_avg_short'),
          pulse_rate_max: this.$t('dashboard_new_evollu.measurement_types.pulse_rate_max_short'),
          pulse_rate_min: this.$t('dashboard_new_evollu.measurement_types.pulse_rate_min_short'),
          pulse_rate_avg: this.$t('dashboard_new_evollu.measurement_types.pulse_rate_avg_short'),
          body_temperature: this.$t('dashboard_new_evollu.measurement_types.body_temperature'),
          forced_expiratory_volume_6_sec: this.$t('dashboard_new_evollu.measurement_types.forced_expiratory_volume_6_sec_short'),
          forced_expiratory_volume_1_sec: this.$t('dashboard_new_evollu.measurement_types.forced_expiratory_volume_1_sec_short'),
          fev1_fev6: this.$t('dashboard_new_evollu.measurement_types.fev1_fev6_short'),
          forced_mid_expiratory_flow_25_75: this.$t('dashboard_new_evollu.measurement_types.forced_mid_expiratory_flow_25_75_short'),
          body_weight: this.$t('dashboard_new_evollu.measurement_types.body_weight_short'),
          body_mass_index: this.$t('dashboard_new_evollu.measurement_types.body_mass_index_short'),
          body_water_percentage: this.$t('dashboard_new_evollu.measurement_types.body_water_percentage_short'),
          body_fat_percentage: this.$t('dashboard_new_evollu.measurement_types.body_fat_percentage_short'),
          body_muscle_mass: this.$t('dashboard_new_evollu.measurement_types.body_muscle_mass_short'),
          frailty_accessment_result: this.$t('dashboard_new_evollu.measurement_types.frailty_accessment_result_short'),
          frailty_exhaustion_result: this.$t('dashboard_new_evollu.measurement_types.frailty_exhaustion_result_short'),
          frailty_physical_activity: this.$t('dashboard_new_evollu.measurement_types.frailty_physical_activity_short'),
          frailty_walk_time: this.$t('dashboard_new_evollu.measurement_types.frailty_walk_time_short'),
          frailty_dominant_strength: this.$t('dashboard_new_evollu.measurement_types.frailty_dominant_strength_short'),
          frailty_weight_loss: this.$t('dashboard_new_evollu.measurement_types.frailty_weight_loss_short'),
          sarc_f: this.$t('dashboard_new_evollu.measurement_types.sarc_f_short'),
          hand_grip: this.$t('dashboard_new_evollu.measurement_types.hand_grip_short'),
          gait_speed: this.$t('dashboard_new_evollu.measurement_types.gait_speed_short'),
          sarc_result: this.$t('dashboard_new_evollu.measurement_types.sarc_result_short'),
          fasting: this.$t('dashboard_new_evollu.measurement_types.fasting_short'),
          blood_glucose: this.$t('dashboard_new_evollu.measurement_types.blood_glucose_short'),
          actions: this.$t('tables.columns.actions'),
          hl_left: this.$t('dashboard_new_evollu.measurement_types.hl_left'),
          hl_right: this.$t('dashboard_new_evollu.measurement_types.hl_right'),
          hl: this.$t('dashboard_new_evollu.measurement_types.hl_result'),
          automatic: this.$t('checkup_plus.person.measurements.automatic')
        },
        skin: 'table table-striped table-hover is-fullwidth',
        pagination: {
          chunk: 5,
          nav: 'scroll'
        },
        columnsClasses: {
          actions: 'actions',
          automatic: 'actions'
        }
      },
    }
  },
  created() {
    this.hearingTestData = {
      hl_left: this.data[0].hl_left,
      hl_right: this.data[0].hl_right,
      hl_result: this.data[0].hl_raw,
      result: this.data[0].result_graph_str
    }
  },
  computed: {
  },
  methods: {
    showAudiogramGraph: function ({row}) {
      this.hearingTestData = {
        hl_left: row.hl_left,
        hl_right: row.hl_right,
        hl_result: row.hl_raw,
        result: row.result_graph_str
      }
      this.tabValue = 1
    }
  }
}
</script>
<style scoped lang="scss">
.chart{
  canvas{
    width:1000px !important;
    height:600px !important;
  }
}

.chart-wrapper {
  width: 100%;
  height: 400px;
  margin-top: 1rem;
  margin-bottom: 0.4rem;
  margin-right: 7.5%;
}
</style>
<style lang="scss">
.actions {
  text-align: center;
}
</style>
